import { type Project } from '@owl-nest/api-client/latest'

import { getAnalyticsTags } from '../analyticsTags'
import { type SafePush } from '../safePush'
import { type LeadTracking } from './types'
import { EVENT_TYPE } from '../types'

export function tracking(safePush: SafePush, project?: Project<'analytics'>): LeadTracking {
  const analyticsTags = getAnalyticsTags(project)
  return {
    track: ({ leadSource = undefined, ...params }) => {
      safePush({
        event: EVENT_TYPE.GENERATE_LEAD,
        leadSource,
        ...(analyticsTags !== undefined && { poTagIDs: analyticsTags }),
        ...params,
      })
    },
  }
}
